import {connect} from "react-redux"
import Cookies from "js-cookie"
import {getCookieValue} from "../../../../utils/cookies"
import {getAutoCompleteThunk, BR_UID_2} from "../../../../ducks/autocomplete"
import {State} from "../../../../ducks"

export const mapStateToProps = (state: State) => {
    const {parameters, numFound, suggestions, isLoading} = state.autocomplete
    const cookie = state.request?.headers?.cookie
    const {
        text: {autoComplete},
        template,
        settings: {xxlBreakpointEnabled, isAutoSuggestHighlightEnabled},
    } = state
    const isNoResults = !isLoading && suggestions && suggestions.length === 0 && numFound === 0

    return {
        text: autoComplete,
        isLoading,
        parameters,
        numFound,
        suggestions,
        cookie,
        isNoResults,
        templating: template,
        xxlBreakpointEnabled,
        showSelectionHighlight: isAutoSuggestHighlightEnabled,
    }
}

export const mapDispatchToProps = (dispatch: any) => ({
    getAutoCompleteThunk: ({term, parameters, cookie}: {term: string; parameters: any; cookie: string}) => {
        const terr = parameters?.territory || ""
        const uid2 = cookie ? getCookieValue(BR_UID_2, cookie) : Cookies.get(BR_UID_2)
        const updateProductsOnly = true
        dispatch(getAutoCompleteThunk(term, uid2, terr, updateProductsOnly))
    },
})

export default connect(mapStateToProps, mapDispatchToProps)
